import type { ColumnDef } from "@tanstack/react-table";

import type { NotificationTable } from "./types";
import { DataTableCenteredCell } from "@/shared/ui/DataTable";
import { ReadNotificationButton } from "@/features/ReadNotificationButton";
import { VerdictNotificationButtons } from "@/features/VerdictNotificationButtons";
import { formatDate } from "@/shared/lib/utils";
import { SortButton } from "@/features/SortButton/SortButton";
import { Modal } from "@/shared/ui/Modal";

export const NotificationColumns: ColumnDef<NotificationTable>[] = [
  {
    accessorKey: "type",
    header: () => <SortButton title="Тип" sort="type" />,
    cell: ({ row }) => (
      <div className="mx-2 flex-grow capitalize">
        {row.original.notification.type}
      </div>
    ),
  },
  {
    accessorKey: "text",
    header: () => <SortButton title="Текст" sort="text" />,
    cell: ({ row }) => (
      <div className="flex">
        <div className="w-full max-w-24 self-center overflow-hidden truncate text-ellipsis whitespace-nowrap text-textColor md:max-w-96">
          {row.original.notification.text}
        </div>
        <Modal>
          <Modal.Trigger variant="link">Раскрыть</Modal.Trigger>
          <Modal.Content>
            <Modal.Title>Текст уведомления</Modal.Title>

            <span className="text-textColor">
              {row.original.notification.text}
            </span>

            <Modal.Close>Закрыть</Modal.Close>
          </Modal.Content>
        </Modal>
      </div>
    ),
  },
  {
    accessorKey: "createdAt",
    header: () => (
      <DataTableCenteredCell>
        <SortButton title="Дата" sort="createdAt" />
      </DataTableCenteredCell>
    ),
    cell: ({ row }) => (
      <div className="flex-grow text-center font-semibold">
        {row.original.createdAt ? formatDate(row.original.createdAt) : "N/A"}
      </div>
    ),
  },
  {
    id: "needVerdict",
    accessorKey: "needVerdict",
    header: () => <DataTableCenteredCell>Действия</DataTableCenteredCell>,
    cell: ({ row }) => {
      const verdict = row.original.notification.needVerdict;
      const id = row.original._id;
      return (
        <DataTableCenteredCell>
          <div className="flex gap-2">
            {verdict ? (
              <VerdictNotificationButtons id={id} />
            ) : (
              <ReadNotificationButton id={id} />
            )}
          </div>
        </DataTableCenteredCell>
      );
    },
  },
];
